export const Sites = {
    COJP_SITE: "COJP",
    BUSINESS_SITE: "BUSINESS",
    BUSINESS_EDITDASH_SITE: "BUSINESS",
    QUICKTAKE_SITE: "QUICKTAKE",
    COJP_PATH: "COJP_PATH",
} as const;

export const {
    COJP_SITE,
    BUSINESS_SITE,
    BUSINESS_EDITDASH_SITE,
    QUICKTAKE_SITE,
    COJP_PATH,
} = Sites;
